<script lang="ts" setup>
import { ref, provide, inject } from 'vue';
import { RouterView } from 'vue-router';
import PageHeaderOne from './components/PageHeaderOne.vue';
import PageHeaderTwo from './components/PageHeaderTwo.vue';
import PageFooter from './components/PageFooter.vue';
import Popup from './components/Popup.vue';

const appClass = ref('');
const loading = inject('app-loading');

provide('app-class', appClass);
</script>

<template>
  <Transition name="fade">
    <div class="preloader" v-if="loading">
      <div class="loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </Transition>
  <div class="page-app" :class="[appClass]">
    <PageHeaderTwo v-if="$route.path === '/'" />
    <PageHeaderOne v-else />
    <RouterView />
    <PageFooter />
    <Popup class="<sm:hidden" />
  </div>
</template>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
